import { tokens } from "../tokens";

// The one document level stylesheet: paints the ground, sets the content font, and declares the
// keyframes every entrance and the live mark reuse. Built from tokens so no colour or duration is
// declared twice. Mount once at the app root, above the router.
//
// Entrance rises through a transform, which is a composited move: the element keeps its laid out box
// from the first frame, so nothing below it shifts while the sequence plays.
const css = `
	:root {
		color-scheme: dark;
	}
	* { box-sizing: border-box; }
	html, body {
		margin: 0;
		padding: 0;
		background: ${tokens.color.ground};
		color: ${tokens.color.text.primary};
		font-family: ${tokens.font.sans};
		font-size: ${tokens.size.body}px;
		line-height: ${tokens.line.body};
		-webkit-font-smoothing: antialiased;
		text-rendering: optimizeLegibility;
	}
	#root { min-height: 100vh; }
	a { color: ${tokens.color.accent.blue}; text-decoration: none; }
	button { font-family: inherit; }
	input { font-family: inherit; }

	:focus-visible {
		outline: ${tokens.border.focus}px solid ${tokens.color.stroke.strong};
		outline-offset: ${tokens.border.focus}px;
		border-radius: ${tokens.radius.sm}px;
	}

	@keyframes mm-enter {
		from { opacity: 0; transform: translateY(${tokens.motion.rise}px); }
		to   { opacity: 1; transform: translateY(0); }
	}

	/* The one moving thing on a run: a slow breath that says a step is being worked on now. */
	@keyframes mm-breath {
		0%, 100% { opacity: 0.55; transform: scale(0.9); }
		50%      { opacity: 1; transform: scale(1); }
	}

	@keyframes mm-skeleton {
		0%   { opacity: 0.5; }
		50%  { opacity: 0.9; }
		100% { opacity: 0.5; }
	}

	/* Indeterminate spinner that replaces a working control's label. */
	@keyframes mm-spin {
		to { transform: rotate(360deg); }
	}

	@media (prefers-reduced-motion: reduce) {
		* { animation-duration: 0.001ms !important; animation-iteration-count: 1 !important; }
		.mm-enter { animation: none !important; }
	}
`;

// Injects the base stylesheet. Renders nothing visible.
export function GlobalStyle() {
	return <style>{css}</style>;
}
